<h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">Delete {{dialogDataInstance.school_name}}</h2>
<mat-dialog-content>
    <p class="text-center m-0 h3">Students may be associated with the school {{dialogDataInstance.school_name}}. <br>
        Are you sure you want to delete ?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="dialogRef.close(false)">Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="dialogRef.close(true)" cdkFocusInitial>Yes</button>
</mat-dialog-actions>